import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const OrderService = {};

OrderService.getOrders = function (params) {
  return fetch({
    url: ApiConstant.ORDER_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
OrderService.getPaymentStatus = function (params) {
  return fetch({
    url: ApiConstant.ORDER_CHECK_PAYMENT_STATUS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
OrderService.getSingleOrder = function (params) {
  return fetch({
    url: ApiConstant.ORDER_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
OrderService.updateOrderStatus = function (data, params) {
  return fetch({
    url: ApiConstant.ORDER_UPDATE_STATUS,
    method: "PUT",
    data: { booking_status: data.status },
    params: Utils.filterHeaderParams(params),
  });
};
OrderService.updateRefundStatus = function (data, params) {
  return fetch({
    url: ApiConstant.REFUND_STATUS_UPDATE,
    method: "PUT",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
OrderService.updateOrderBulkStatus = function (data, status) {
  const payload = {
    status: status,
    ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.ORDER_UPDATE_BULK_STATUS,
    method: "PATCH",
    data: payload,
  });
};
OrderService.getOrderNotes = function (params) {
  return fetch({
    url: ApiConstant.ORDER_NOTES_GET,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
OrderService.addOrderNotes = function (data, params) {
  return fetch({
    url: ApiConstant.ORDER_NOTES_ADD,
    method: "POST",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
OrderService.downalodOrderExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.ORDER_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};
OrderService.bulkInvoiceDetails = function (orderIds) {
  const order_ids = Array.isArray(orderIds) ? orderIds : [orderIds];

  return fetch({
    url: ApiConstant.ORDER_INVOICE_BULK_DOWNLOAD,
    method: "POST",
    data: { order_ids },
    timeout: 180000,
  });
};


export default OrderService;
